import { render, staticRenderFns } from "./TrainingPlanItemKeywords.vue?vue&type=template&id=5865dff4&"
import script from "./TrainingPlanItemKeywords.vue?vue&type=script&lang=ts&"
export * from "./TrainingPlanItemKeywords.vue?vue&type=script&lang=ts&"
import style0 from "./TrainingPlanItemKeywords.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports